import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import EventCard from './event/widgets/EventCard';
import { FETCH_EVENTS, EVENTS_SET_ACTIVE } from '../../constants/action-types';

const renderEvent = (event, i) => {

    return (
        <li key={i.toString()}>
            <Link to={'/event/' + event.eventId}>
                {/* <small>{event.event.league}</small>
            <h3>{event.event.team1}</h3>
            <h3>{event.event.team2}</h3>
            <small>Game starts at {new Date(event.event.start_time)}</small> */}
            </Link>
        </li>)

}

class Events extends Component {
    
    constructor(props) {
        
        super(props);

    }

    componentWillMount() {

        this.props.getEvents()

    }

    componentWillUpdate() {


    }

    render() {
        // debugger;
        return (
            <section id='events' className='content-section-wrap'>
                <div id='events-head' className='content-section-head'>
                    <h1 className='mvu-head xl'>2018 FIFA WORLD CUP BOUNTY</h1>
                    <ul id='events-game-stats'>
                        <li id='events-game-stats-games-open'>
                            <div className='mvu-status green'>
                                <div className='mvu-status-indicator'></div>
                                <small>{this.props.events.length} games open</small>
                            </div>
                        </li>
                        {/* <li id='events-game-stats-games-open'>
                            <div className='mvu-status orange'>
                                <div className='mvu-status-indicator'></div>
                                <small>0 games pending</small>
                            </div>
                        </li> */}
                        <li id='events-game-stats-games-open'>
                            <div className='mvu-status red'>
                                <div className='mvu-status-indicator'></div>
                                <small>{60 - this.props.events.length} games closed</small>
                            </div>
                        </li>
                    </ul>
                </div>
                <div id='events-list-wrap' className='content-section'>
                    {(this.props.events.length === 0 && !this.props.loading) ? (
                        <div className='content-section-empty'>
                            <h1>No events found</h1>
                        </div>
                    ) : null}
                    {this.props.loading ? (
                        <div className='content-section-empty'>
                            <h1>Loading</h1>
                        </div>)
                    : null}
                    {this.props.events.length !== 0 ? (
                            <ul id='events-list'>
                                {this.props.events.map((event, i) => {
                                    return <li key={i.toString()} className='event-wrap'>
                                        <Link to={'events/' + event.eventId}>
                                            <EventCard event={event} >
                                            </EventCard>
                                        </Link>
                                    </li>
                                })}
                            </ul>
                    ) : null}
                </div>
            </section>
        );
    }
}

const mapStateToProps = (state) => state.events

const mapDispatchToProps = (dispatch) => ({
    getEvents: () => dispatch({ type: FETCH_EVENTS }),
    setActiveEvent: () => dispatch({ type: EVENTS_SET_ACTIVE })
   
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Events)



// WEBPACK FOOTER //
// ./src/components/general/Events.js